export default __webpack_public_path__ + "static/media/regulatory--end-of-parking-zone--g1.cfb44d95.png";